"use client";

import Link from "next/link";
import { useState } from "react";

import PhoneNumberModal from "../modals/PhoneNumberModal";

import { useMediaQuery } from "@/hooks/useMediaQuery";

interface PhoneLinkProps {
  phoneNumber: string;
  linkClassNames?: string;
  buttonClassNames?: string;
  children: React.ReactNode;
}

const PhoneLink = ({ phoneNumber, linkClassNames, buttonClassNames, children }: PhoneLinkProps) => {
  const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);
  const isTabletOrLarger = useMediaQuery("(min-width: 768px)");

  if (isTabletOrLarger) {
    return (
      <>
        <button onClick={() => setIsPhoneNumberModalOpen(true)} className={buttonClassNames}>
          {children}
        </button>
        <PhoneNumberModal
          isOpen={isPhoneNumberModalOpen}
          onClose={() => setIsPhoneNumberModalOpen(false)}
          phoneNumber={phoneNumber}
        />
      </>
    );
  }

  return (
    <Link href={`tel:${phoneNumber}`} className={linkClassNames}>
      {children}
    </Link>
  );
};

export default PhoneLink;
